import {z} from 'zod';

export const authPerspectiveSchema = z.enum(['member', 'staff']);
/** Defines the UX of the login form and adjacent UIs. For example: login attempts from my-dot will declare the 'staff' perspective */
export type AuthPerspective = z.infer<typeof authPerspectiveSchema>;

export const parseAuthPerspective = (
  value: unknown
): AuthPerspective | undefined => {
  const parsed = authPerspectiveSchema.safeParse(value);
  return parsed?.data;
};
